import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              漫画分类
            </h2>
            <p className="text-sm text-foreground-500">七大漫画分类，精准找到你喜欢的题材</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item) => (
              <div
                key={item.id}
                className="flex items-start gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-secondary-300 transition-all duration-300 cursor-pointer group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 shrink-0 group-hover:bg-secondary-200 transition-colors">
                  <i className={`${item.icon} text-secondary-700 text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-heading text-sm font-bold text-foreground-900">{item.name}</h3>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}